import { useContext } from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box, MenuItem } from '@mui/material';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TraitsReconciliationContext from '../../context/TraitsReconciliationContext';

const Label = styled.span(({ theme }) => `
    font-family: ${theme.typography.fontFamily};
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0;
    vertical-align: middle;
    color: ${theme.palette.grey[700]};
    display: block;
    margin: 10px 0 10px 0;
`);

const StyledSelect = styled(Select)(({ theme }) => `
    && {
        background-color: ${theme.palette.background.paper};
        font-family: ${theme.typography.fontFamily};
        font-weight: 400;
        font-size: 14px;
        width: 100%;
        color: ${theme.palette.grey[900]};
        &.Mui-disabled {
            background-color: ${theme.palette.action.disabledBackground};
        }
    }
`);

const StyledMenuItem = styled(MenuItem)(({ theme }) => `
  && {
    font-family: ${theme.typography.fontFamily};
    font-size: 14px;
    min-height: 40px;
    font-weight: 400;
    &.Mui-selected {
      background-color: ${theme.palette.grey[200]};
      &:hover {
        background-color: ${theme.palette.grey[200]};
      }
    }
  }
`);

function StudySelector() {
  const { studies, currentStudy, setCurrentStudy } = useContext(TraitsReconciliationContext);
  const { t } = useTranslation();
  if (!studies || studies.length === 0) {
    return null;
  }
  const handleStudyChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string;
    const selectedStudy = studies.find((study) => study.studyId === value);
    if (selectedStudy) {
      setCurrentStudy(selectedStudy);
    }
  };

  return (
    <Box sx={{ paddingBottom: '20px' }}>
      <Label>{t('Study')}</Label>
      <StyledSelect
        size="small"
        value={currentStudy?.studyId || ''}
        disabled={studies.length < 2}
        onChange={handleStudyChange}
        inputProps={{
          'data-testid': 'study-selector',
        }}
      >
        {studies.map(({ protocolNumber, studyId }) => (
          <StyledMenuItem key={studyId} value={studyId} data-testid={`study-option-${protocolNumber}`}>
            {protocolNumber}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </Box>
  );
}

export default StudySelector;
